module.exports = __webpack_public_path__ + "img/svg - mid window.858f86bd.svg";